// extracted by mini-css-extract-plugin
export default {"button":"Button_button__6d0Ru","reverse":"Button_reverse__OmQCG","inverse":"Button_inverse__qKrb4"};